import React from "react";
import { Box, Typography } from "@mui/material";
import ConfirmDialog from "../../components/common/ConfirmDialog";
import { COLORS, TYPO } from "../../styles/uiConstants";
import { typeLabelOf } from "./deviceListModel";

export default function DeviceDeleteDialog({ open, onClose, device, onConfirm, isDeleting }) {
  const patient = device?.patient ? `${device.patient.name || ""} ${device.patient.surname || ""}`.trim() : null;
  return (
    <ConfirmDialog
      open={open}
      onClose={onClose}
      onConfirm={onConfirm}
      title="Cihazı sil"
      confirmText="Cihazı sil"
      cancelText="Vazgeç"
      confirmVariant="error"
      loading={isDeleting}
      loadingText="Siliniyor..."
      message={
        <Box sx={{ display: "flex", flexDirection: "column", gap: 1.5 }}>
          <Typography sx={{ fontSize: TYPO.body, color: COLORS.slate700 }}>
            <Box component="span" sx={{ fontFamily: "'SF Mono', 'Fira Code', monospace", fontWeight: 600 }}>
              {device?.serialNo}
            </Box>{" "}
            ({typeLabelOf(device)}) sistemden kalıcı olarak silinecek. Bu işlem geri alınamaz.
          </Typography>
          {patient ? (
            <Typography sx={{ fontSize: TYPO.body, color: COLORS.errorDark }}>
              Cihaz şu an {patient} adlı hastaya bağlı; bağ da kaldırılacak.
            </Typography>
          ) : null}
        </Box>
      }
    />
  );
}
